/**
 * Set up tabs
 *
 * Sets up accessibility and behavior for tabs. Can work with either
 * one list of label toggles, or multiple (e.g. if goes from a tab
 * nav to an accordion at mobile).
 *
 * Example:

tabs('my-tabs', { // slug
	expandFirstTab: true, // on load pre-expand first tab
	oneAlwaysOpen: true, // dont collapse open tabs on click
	selectors: {
		wrap: '.my-tabs', // main wrapper containing all tab features
		toggles: ['.my-tabs__button--desk', '.my-tabs__button--mobile'], // string for one trigger or array for multiple
		content: '.tabs-item__content', // content area that gets expanded
	},
})

 *
 */
const tabs = (name, opt) => {
	const tabWraps = document.querySelectorAll(opt.selectors.wrap)
	if (tabWraps) {
		tabWraps.forEach((tab, i) => {
			// set up content sections
			const id = `${name}-${i}`
			const content = tab.querySelectorAll(opt.selectors.content)
			const amount = content.length

			// set up toggles
			const togglesArr = []
			const toggleSelectors =
				typeof opt.selectors.toggles === 'string' ? [opt.selectors.toggles] : opt.selectors.toggles
			toggleSelectors.forEach((toggleSelector) => {
				const sluggish = toggleSelector.replace(/[^a-zA-Z ]/g, '')
				togglesArr.push({
					sluggish,
					el: tab.querySelectorAll(toggleSelector),
				})
			})

			// handle clicks
			const setTab = (index) => {
				togglesArr.forEach((toggles) => {
					toggles.el.forEach((el, j) => {
						const inactive = opt.oneAlwaysOpen ? true : el.getAttribute('aria-selected') === 'false'
						el.setAttribute('aria-selected', false)
						if (j === index && inactive) {
							el.setAttribute('aria-selected', true)
						}
					})
				})
				content.forEach((el, j) => {
					const inactive = opt.oneAlwaysOpen ? true : el.getAttribute('aria-hidden') === 'true'
					el.setAttribute('aria-hidden', true)
					el.setAttribute('tabindex', -1)
					if (j === index && inactive) {
						el.setAttribute('aria-hidden', j !== index)
						el.setAttribute('tabindex', 0)
					}
				})
			}

			// loop each item using content number as assumed amount
			for (let j = 0; j < amount; j++) {
				// set up this particular iteration's ID
				const subId = `${id}-${j}`

				// apply accessibility to content
				content[j].setAttribute('id', subId)
				content[j].setAttribute('aria-hidden', opt.expandFirstTab ? !!j : true)
				content[j].setAttribute('role', 'tabpanel')
				content[j].setAttribute('tabindex', opt.expandFirstTab && !j ? 0 : -1)

				// set up the toggle(s)
				togglesArr.forEach((toggles, ij) => {
					const toggleId = `${toggles.sluggish}-${subId}`
					toggles.el[j].setAttribute('id', toggleId)
					toggles.el[j].setAttribute('role', 'tab')
					toggles.el[j].setAttribute('aria-controls', `${subId}`)
					toggles.el[j].setAttribute('aria-selected', opt.expandFirstTab ? !j : false)
					toggles.el[j].addEventListener('click', () => setTab(j))
					// only set labelledby of content based on first controls found (index 0)
					if (!ij) {
						content[j].setAttribute('aria-labelledby', toggleId)
					}
				})
			}
		})
	}
}

export default tabs
